import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgEnlarge32 = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path d="M16.24 21.232A9.5 9.5 0 1 1 22 12.5a9.454 9.454 0 0 1-1.537 5.171 9.535 9.535 0 0 1-4.223 3.561zm11.872 4.089-6.925-6.925A10.443 10.443 0 0 0 23 12.5C23 6.701 18.299 2 12.5 2S2 6.701 2 12.5C2 18.298 6.701 23 12.5 23c1.608 0 3.126-.372 4.489-1.019l7.231 7.231a1.103 1.103 0 0 0 1.562.006l2.336-2.335a1.102 1.102 0 0 0-.006-1.562z" />
      <path d="M16.002 11.041h-2.127V8.998c0-.552-.322-.957-.874-.957h-1.002c-.556 0-1.124.406-1.124.957v2.043H8.998c-.552 0-1.123.406-1.123.958v1.002c0 .556.572 1.04 1.123 1.04h1.877v1.962c0 .551.572 1.038 1.124 1.038h1.002c.556 0 .874-.487.874-1.038v-1.962h2.127c.552 0 .873-.488.873-1.04v-1.002c0-.556-.322-.958-.873-.958z" />
    </SvgIcon>
  );
};
const Memo = memo(SvgEnlarge32);
export default Memo;
